import { render, staticRenderFns } from "./AddJobForm.vue?vue&type=template&id=131b6a27&"
import script from "./AddJobForm.vue?vue&type=script&lang=js&"
export * from "./AddJobForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports